import {
	resolveZoneOverlayColors,
	ZONE_COLOR_OPTIONS,
} from "@sitescene/shared";

export const DEFAULT_OVERLAY_SWATCH = ZONE_COLOR_OPTIONS[0]!.overlay;

const resolveOverlaySwatch = (feature: GeoJSON.Feature) => {
	const zoneColor = feature.properties?.zoneColor;
	if (typeof zoneColor === "string" && zoneColor.trim()) {
		return resolveZoneOverlayColors(zoneColor);
	}

	return DEFAULT_OVERLAY_SWATCH;
};

/** Stamps stable light/dark swatch hexes onto each overlay feature. */
export const assignOverlayColors = (
	features: GeoJSON.Feature[],
): GeoJSON.Feature[] =>
	features.map((feature) => {
		const swatch = resolveOverlaySwatch(feature);
		return {
			...feature,
			properties: {
				...feature.properties,
				overlayColorDark: swatch.dark,
				overlayColorLight: swatch.light,
			},
		};
	});

export const normalizeOverlays = (
	overlays?: GeoJSON.Feature[] | GeoJSON.FeatureCollection,
): GeoJSON.FeatureCollection => {
	if (!overlays) {
		return { features: [], type: "FeatureCollection" };
	}
	const features = Array.isArray(overlays) ? overlays : overlays.features;
	return { features: assignOverlayColors(features), type: "FeatureCollection" };
};
